import React, {useEffect, useMemo, useState} from "react";
import {Input} from "antd";
import debounce from "lodash/debounce";

export const DebouncedInput = ({value, onChange, placeholder, delay = 400}) => {
    const [text, setText] = useState(value || "");

    useEffect(() => {
        setText(value || "");
    }, [value]);

    const emitChange = useMemo(() => debounce(onChange, delay), [onChange, delay]);

    useEffect(() => () => emitChange.cancel(), [emitChange]);

    return (
        <Input
            allowClear
            value={text}
            placeholder={placeholder}
            onChange={event => {
                setText(event.target.value);
                emitChange(event.target.value);
            }}
        />
    );
};
